import { translateLabel } from "@/i18n/messages";
export const trailCommunityRatingText = (summary = {}) => {
  const count = Number(summary.count) || 0;
  const average = Number(summary.average);
  if (count === 0 || !Number.isFinite(average)) return translateLabel("No BPF ratings yet");
  return translateLabel(count === 1 ? "{average} · {count} rating" : "{average} · {count} ratings", { average: average.toFixed(1), count });
};

export const normalizedTrailRating = (value) => {
  const rating = Number(value);
  return Number.isInteger(rating) && rating >= 1 && rating <= 5 ? rating : 0;
};
